import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: {
    backgroundColor: 'black'
  }
});
//# sourceMappingURL=styles.js.map